import * as service from './service'
export default {
  namespace: 'recruitEquipmentPayInfoNewTwo',
  state: {
    paymentInfoData: {
      applyPrice: 0,
      registerCost: 0
    },
    oneData: { selectTxt: [], saleSkuInfo: {} },
    twoData: { selectTxt: [], saleSkuInfo: {} },
    threeData: { selectTxt: [], saleSkuInfo: {} },
    selSimData: true
  },
  effects: {
    * getData ({ payload }, { call, put }) {
      const res = yield call(service.selectInfo, payload)
      if (res.data.status === 200) {
        yield put({
          type: 'save',
          payload: {
            paymentInfoData: res.data.data
          }
        })
        return res.data
      }
    },
    * getSimData ({ payload }, { call, put }) {
      const res = yield call(service.cityStatus, payload)
      return res.data
    },
    * setOneEquipmentData ({ oneData }, { call, put }) {
      yield put({ type: 'SAVE_ONE_EQUIPMENT_DATA', oneData })
    },
    * setTwoEquipmentData ({ twoData }, { call, put }) {
      yield put({ type: 'SAVE_TWO_EQUIPMENT_DATA', twoData })
    },
    * setThreeEquipmentData ({ threeData }, { call, put }) {
      yield put({ type: 'SAVE_THREE_EQUIPMENT_DATA', threeData })
    },
    * showInRecruit ({ payload }, { call, put }) {
      const res = yield call(service.showInRecruit, payload)
      return res.data
    },
    * setSelectSimData ({ selSimData }, { call, put }) {
      yield put({ type: 'SET_SELECT_SIMDATA', selSimData })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    },
    SAVE_ONE_EQUIPMENT_DATA (state: any, { oneData }) {
      return { ...state, oneData }
    },
    SAVE_TWO_EQUIPMENT_DATA (state: any, { twoData }) {
      return { ...state, twoData }
    },
    SAVE_THREE_EQUIPMENT_DATA (state: any, { threeData }) {
      return { ...state, threeData }
    },
    SET_SELECT_SIMDATA (state: any, { selSimData }) {
      return { ...state, selSimData }
    }
  }
}
